import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "./ui/button";
import logo from "../assets/img/logo3.png";

export function Header() {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Simula usePathname()
  const pathname = location.pathname;

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, [pathname]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setIsLoggedIn(false);
    window.location.href = "/";
  };

  return (
    <header className="border-b border-border bg-white sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="GeoGas Logo" className="h-12 w-auto" />
        </Link>

        {/* Mobile menu button */}
        <button
          className="md:hidden"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <Menu className="h-6 w-6" />
        </button>

        {/* Desktop navigation */}
        <nav className="hidden md:flex items-center gap-6">
          <Link
            to="/"
            className={`transition-colors ${
              pathname === "/" ? "text-[#0288d0] font-semibold" : "text-foreground hover:text-[#0288d0]"
            }`}
          >
            Inicio
          </Link>
          <Link
            to="/map"
            className={`transition-colors ${
              pathname === "/map" ? "text-[#0288d0] font-semibold" : "text-foreground hover:text-[#0288d0]"
            }`}
          >
            Localizar gas
          </Link>
          {!isLoggedIn ? (
            <>
              <Link
                to="/register"
                className={`transition-colors ${
                  pathname === "/register" ? "text-[#0288d0] font-semibold" : "text-foreground hover:text-[#0288d0]"
                }`}
              >
                Registrarse
              </Link>
              <Link to="/login">
                <Button
                  variant="outline"
                  className="border-[#0288d0] text-[#0288d0] hover:bg-[#0288d0] hover:text-white bg-transparent"
                >
                  Iniciar sesión
                </Button>
              </Link>
            </>
          ) : (
            <>
              <Link
                to="/profile"
                className={`transition-colors ${
                  pathname === "/profile" ? "text-[#0288d0] font-semibold" : "text-foreground hover:text-[#0288d0]"
                }`}
              >
                Profile
              </Link>
              <Button
                onClick={handleLogout}
                variant="outline"
                className="border-[#0288d0] text-[#0288d0] hover:bg-[#0288d0] hover:text-white bg-transparent"
              >
                Cerrar sesión
              </Button>
            </>
          )}
        </nav>

        {/* Mobile navigation */}
        {mobileMenuOpen && (
          <nav className="absolute top-full left-0 right-0 bg-white border-b border-border md:hidden shadow-lg">
            <div className="flex flex-col p-4 gap-4">
              <Link to="/" className="text-foreground hover:text-[#0288d0]" onClick={() => setMobileMenuOpen(false)}>
                Inicio
              </Link>
              <Link to="/map" className="text-foreground hover:text-[#0288d0]" onClick={() => setMobileMenuOpen(false)}>
                Localizar gas
              </Link>
              {!isLoggedIn ? (
                <>
                  <Link to="/register" className="text-foreground hover:text-[#0288d0]" onClick={() => setMobileMenuOpen(false)}>
                    Registrarse
                  </Link>
                  <Link to="/login" className="text-foreground hover:text-[#0288d0]" onClick={() => setMobileMenuOpen(false)}>
                    Iniciar sesión
                  </Link>
                </>
              ) : (
                <>
                  <Link to="/profile" className="text-foreground hover:text-[#0288d0]" onClick={() => setMobileMenuOpen(false)}>
                    Perfil
                  </Link>
                  <button onClick={() => { handleLogout(); setMobileMenuOpen(false); }} className="text-left text-foreground hover:text-[#0288d0]">
                    Cerrar sesión
                  </button>
                </>
              )}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}